export var hideControlsClassName = 'mvng-hide-controls';
//# sourceMappingURL=classNames.js.map